import React from "react";

import {
    WebsiteAnalytics,
    WebsiteContent,
    WebsiteDesign,
    WebsiteDomain,
    WebsiteECommerce,
    WebsiteMarketing,
    WebsiteNew,
} from "../components/Website";

export default function WebsiteContainer(props) {
    return (
        <>
            {props.analytics && <WebsiteAnalytics />}
            {props.content && <WebsiteContent />}
            {props.design && <WebsiteDesign />}
            {props.domain && <WebsiteDomain />}
            {props.ecommerce && <WebsiteECommerce />}
            {props.marketing && <WebsiteMarketing />}
            {props.new && <WebsiteNew preview={props.preview} />}
        </>
    );
}
